import {Component, inject, OnInit} from '@angular/core';
import {RouterModule, RouterOutlet} from '@angular/router';
import {MatToolbarModule} from '@angular/material/toolbar';
import {MatCardModule} from '@angular/material/card';
import {MatDividerModule} from '@angular/material/divider';
import {LoginService} from './services/login.service';

@Component({
  selector: 'app-root',
  imports: [
    RouterOutlet,
    MatToolbarModule,
    MatCardModule,
    RouterModule,
    MatDividerModule,
  ],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent implements OnInit{
  title = 'hybryd-pdf-builder';
  loginService = inject(LoginService);

  ngOnInit(){
    document.addEventListener('wheel', function(event) {
      if (event.ctrlKey) {
        event.preventDefault(); // Prevent default zoom behavior
      }
    }, { passive: false });
  }
}
